import gql from 'graphql-tag'

export const UPDATE_LOGIN_PW = gql`
    mutation UpdateLoginPW {
        updateLoginPW
    }
`
